import images from 'assets/images/images'
import {useRequest} from 'hooks/useRequest'
import useTranslate from 'hooks/useTranslate'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setAnnouncementModal} from 'redux/popup/popupSlice'
import auth from 'utils/Auth'

const AnnouncementModal = () => {
	const { announcementModal } = useSelector((state) => state.popup)
  const dispatch = useDispatch()
  const { content, open, onApprove } = announcementModal
  const [modalContent, setModalContent] = useState({id:null,title:'',body:''})
  const [contentRequest, contentLoading] = useRequest()
  const {t} = useTranslate() 
  const onClose = () => {
    if (auth.getPopups()) {
      auth.updatePopups({...content,onShowDate:moment()})
    }else {
      auth.setPopups([{...content,onShowDate:moment()}])
    }
    dispatch(setAnnouncementModal({open:false,content:null, onApprove:null}))
  }
  const isTeslimat = content?.title?.toLowerCase()?.includes('teslimat tipi')
  useEffect(() => {
   if (content?.id) {
    const headerOptions = {
        RestaurantId : auth?.getUserChoises()?.restaurantId,
        DeliveryType : auth?.getUserChoises()?.deliveryType,
        NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
        RegionId : auth?.getUserChoises()?.regionId,
        id:content.id
      }
    contentRequest(`/Popup/${content?.id}`, {
      method: 'GET',
      headers: headerOptions
    }).then(res => {
      setModalContent(res?.data?.result)
    })
   }
   if (!open) {
    setModalContent({id:null,title:'',body:''})
   }
  },[content?.id, open])
  return (
    open && <div className="announcement">
      {
        contentLoading && <div className="announcement-modal">
        <div className='skeleton skeleton-text'/>
        <div className='skeleton skeleton-text'/>
        <div className='skeleton skeleton-footer mx-auto'/>
      </div>
      }
    {
      modalContent?.contentType == 0 &&  <div className="announcement-container">
        {
          contentLoading && <div className='skeleton skeleton-text'/>
        }
        <img loading="lazy" className="announcement-container-close" src={images.close} onClick={onClose} alt=""/>
        <img className="announcement-container-fullImage" src={modalContent.imageLink} alt=""/>
        {/* <div className="announcement-container-bottom">
            <Checkbox name='emailPermission' />
          <span>Tekrar Gösterme</span>
        </div> */}
      </div>
    }
    {
      modalContent && modalContent?.contentType == 1 && <div className="announcement-modal">
        <div className="announcement-modal-body">
       
        <img onClick={onClose} src={images.close} className="announcement-modal-body-close" />
          {
            isTeslimat && <img className='announcement-modal-body-attention' src={images.attention} />
          }
          <div className="announcement-modal-body-title">
            {modalContent?.title}
          </div>
          <div className="announcement-modal-body-desc" style={{maxWidth:isTeslimat ? '516px' : '', textAlign: isTeslimat ? 'center' : 'left'}} dangerouslySetInnerHTML={{__html:modalContent?.body}}/>
        </div>
        <div className='d-flex align-items-center gap-3'>
          {
            onApprove ? <>
            <button className="btn-primary-outline" onClick={onClose}>{t('cancel')}</button>
            <button className="btn-primary" onClick={()=>{
              onApprove();
              onClose();
            }}>{t('approve')}</button>
            </>
            : <button className="btn-primary" onClick={onClose}>{t('ok')}</button>
          }
        </div>
        {/* <div className="announcement-modal-checkbox">
          <Checkbox name='emailPermission' className='mb-0' />
          <span>Tekrar Gösterme</span>
        </div> */}
      </div>
    }
</div>
  )
}

export default AnnouncementModal